import { render, staticRenderFns } from "./QuestionarioClinica.vue?vue&type=template&id=0c809fe2&scoped=true"
import script from "./QuestionarioClinica.vue?vue&type=script&lang=js"
export * from "./QuestionarioClinica.vue?vue&type=script&lang=js"
import style0 from "./QuestionarioClinica.vue?vue&type=style&index=0&id=0c809fe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c809fe2",
  null
  
)

export default component.exports